import { useStore } from "effector-react"
import { createEvent, createStore } from "effector"
import type { CourseData, PricingOption } from "entities/course-catalog"

export type TCourseSelect = {
    name: string
    courseData?: CourseData
    pricingOption?: PricingOption
}

export type TPricingSelect = PricingOption

export type TTraing =
    | 'online_1'
    | 'online_2'
    | 'online_3'
    | 'offline_1'
    | 'offline_2'
    | 'offline_3'

export type TTraingSelect = {
    id: TTraing
}

const trainingIdByPricing: Record<`${PricingOption['format']}:${PricingOption['type']}`, TTraing> = {
    'online:individual': 'online_1',
    'online:closed_group': 'online_2',
    'online:group': 'online_3',
    'offline:individual': 'offline_1',
    'offline:closed_group': 'offline_2',
    'offline:group': 'offline_3',
}

export const getTrainingId = (pricing: Pick<PricingOption, 'format' | 'type'>): TTraing =>
    trainingIdByPricing[`${pricing.format}:${pricing.type}`]

const setCourseSelect = createEvent<TCourseSelect | null>()
const setTrainingSelect = createEvent<TTraingSelect | null>()
const setPricingSelect = createEvent<TPricingSelect | null>()

const useCourseSelect = () => useStore($courseSelect)
const useTrainingSelect = () => useStore($trainingSelect)
const usePricingSelect = () => useStore($pricingSelect)

export const $courseSelect = createStore<TCourseSelect | null>(null)
    .on(setCourseSelect, (_, course) => course)

export const $trainingSelect = createStore<TTraingSelect | null>(null)
    .on(setTrainingSelect, (_, t) => t)

export const $pricingSelect = createStore<TPricingSelect | null>(null)
    .on(setPricingSelect, (_, pricing) => pricing)

export const selectors = {
    useCourseSelect,
    useTrainingSelect,
    usePricingSelect
}

export const events = {
    setCourseSelect,
    setTrainingSelect,
    setPricingSelect,
}
